module.exports = __webpack_public_path__ + "static/img/1ok.0420b009.webp";